import { render, staticRenderFns } from "./EmptyOrderButton.vue?vue&type=template&id=c9d7096c&scoped=true&"
import script from "./EmptyOrderButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EmptyOrderButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./EmptyOrderButton.vue?vue&type=style&index=0&id=c9d7096c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d7096c",
  null
  
)

export default component.exports